.renderLabel {
  --render-label-color-rgb: var(--color-white-rgb);
  --render-label-shadow-rgb: var(--color-black-rgb);

  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
  padding: 0.3em;
  color: rgba(var(--render-label-color-rgb), 0.55);
  text-shadow:
    0 0 0.2rem rgba(var(--render-label-shadow-rgb), 0.6),
    0 0 0.4rem rgba(var(--render-label-shadow-rgb), 0.4);
  font-size: clamp(1rem, calc(1rem + var(--render-label-media-size) * 0.00125rem), 2.2rem);
  line-height: 1;
  pointer-events: none;
}

.renderLabelOnLight {
  --render-label-color-rgb: var(--color-black-rgb);
  --render-label-shadow-rgb: var(--color-white-rgb);
}

.renderLabelCompact .renderLabelRest {
  display: none;
}

.renderLabelExpandable {
  pointer-events: auto;

  &:hover .renderLabelRest {
    display: inline;
  }
}
